import request from '../../axios';

export interface IPostSignLoanContractPayload {
  loan_request_guid: string;
}
export const postSignLoanContract = async (
  payload: IPostSignLoanContractPayload,
) => {
  await request.post(`/api/v2/payment/sign-loan-contract`, {
    ...payload,
  });
};
